import type { SortKey } from "@/utils/news";

const sortOptions: { value: SortKey; label: string; icon: string }[] = [
  { value: "time", label: "最新发布", icon: "ri-time-line" },
  { value: "hot", label: "热度最高", icon: "ri-fire-line" },
  { value: "comments", label: "评论最多", icon: "ri-chat-3-line" },
];

interface Props {
  value: SortKey;
  onChange: (next: SortKey) => void;
}

export default function SortTabs({ value, onChange }: Props) {
  return (
    <div className="flex flex-wrap items-center gap-1 rounded-full bg-background-100 p-1">
      {sortOptions.map((opt) => (
        <button
          key={opt.value}
          type="button"
          onClick={() => onChange(opt.value)}
          className={`flex items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
            value === opt.value
              ? "bg-background-50 text-primary-600 shadow-sm"
              : "text-foreground-500 hover:text-primary-600"
          }`}
        >
          <i className={opt.icon} />
          {opt.label}
        </button>
      ))}
    </div>
  );
}